import React, { Component } from 'react';
import { registerAllModules } from "handsontable/registry";
import { Redirect } from 'react-router-dom';
import ApiURL from "../../../api/ApiURL";
import axios from "axios";
import cogoToast from 'cogo-toast';
import LocalStorageHelper from '../../../LocalStorageHelper/LocalStorageHelper';
import PageTitle from '../../home/PageTitle';
import AgGridComponent from '../../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../common/PaginationComponent';
import { mapAgGridSortToApi, mapAgGridFilterToApi } from '../../../utils/agGridServerHelpers';
import dayjs from "dayjs";

const formatAmount = (params) => {
    const value = params.value;
    return value != null ? Number(value).toFixed(2) : "0.00";
};

const formatBookingDate = (params) => {
    const value = params.value;
    if (value == null || value === "") {
        return "";
    }

    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("DD-MM-YYYY") : String(value);
};

class BookingActionCellRenderer extends Component {
    render() {
        const { data, onEdit, onSpotBooking } = this.props;
        if (!data) {
            return null;
        }
        return (
            <div className="d-flex mx-1">
                <div
                    className="text-center table-action-button"
                    title="Select"
                    style={{ cursor: "pointer" }}
                    onClick={() => onEdit(data)}
                >
                    <i className="fa-solid fa-pen-to-square"></i>
                </div>
                <div
                    className="text-center table-action-button"
                    title="Spot Payment"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSpotBooking(data)}
                >
                    <i className="fa-solid fa fa-inr"></i>
                </div>
            </div>
        );
    }
}

class BookingList extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        //register Handsontable's modules
        registerAllModules();
        this.state = {
            redirectBookingStatus: false,
            redirectSpotBookingStatus: false,
            data: [],
            columnDefs: [],
            sortModel: [],
            filterModel: {},
            isTableLoading: true,
            selBookingId: 0,
            currentPage: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalRecords: 0,
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                UserId: userData.UserId,
                UserRole: userData.RoleName
            })
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
        this.getAllColumnDefs();
        this.getAllBookingData();
    }
    //Get all Booking Data
    getAllBookingData = () => {
        const { currentPage, pageSize, sortModel, filterModel } = this.state;
        const param = {
            Skip: (currentPage - 1) * pageSize,
            Take: pageSize,
            ...mapAgGridSortToApi(sortModel),
            ...mapAgGridFilterToApi(filterModel),
        };
        this.setState({ isTableLoading: true });
        axios
            .post(ApiURL.GetAllBooking, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        data: dataResult.Bookings,
                        totalRecords: dataResult?.TotalRecords ?? 0,
                    });
                } else if (respData.StatusCode === 404) {
                    this.setState({
                        data: [],
                        totalRecords: 0,
                    });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isTableLoading: false });
            });
    }
    getAllColumnDefs = () => {
        this.setState({
            columnDefs: [
                {
                    headerName: "Select",
                    colId: "actions",
                    sortable: false,
                    filter: false,
                    floatingFilter: false,
                    resizable: false,
                    width: 90,
                    flex: 0,
                    suppressSizeToFit: true,
                    pinned: "left",
                    cellClass: "text-center table-action-cell",
                    headerClass: "text-center",
                    cellRenderer: BookingActionCellRenderer,
                    cellRendererParams: {
                        onEdit: this.handleEdit,
                        onSpotBooking: this.handleSpotBooking,
                    },
                },
                { headerName: "Booking No.", field: "BookingNo", width: 150, minWidth: 115 },
                {
                    headerName: "Booking Date",
                    field: "BookingDate",
                    width: 150,
                    minWidth: 115,
                    cellClass: "text-center",
                    headerClass: "text-center",
                    valueFormatter: formatBookingDate,
                },
                {
                    headerName: "Customer",
                    field: "CustomerName",
                    flex: 1.5,
                    minWidth: 140,
                    cellClass: "text-left",
                },
                { headerName: "Mobile", field: "Mobile", width: 135, minWidth: 95 },
                {
                    headerName: "Destination",
                    field: "TravelDestination",
                    flex: 1.5,
                    minWidth: 140,
                    cellClass: "text-left",
                },
                { headerName: "Booking Type", field: "BookingType", width: 130, minWidth: 115 },
                {
                    headerName: "Payable Amount",
                    field: "PayableAmount",
                    width: 145,
                    minWidth: 130,
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    valueFormatter: formatAmount,
                },
                {
                    headerName: "Paid Amount",
                    field: "PaidAmount",
                    width: 145,
                    minWidth: 115,
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    valueFormatter: formatAmount,
                },
                {
                    headerName: "Due Amount",
                    field: "DueAmount",
                    width: 145,
                    minWidth: 115,
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    valueFormatter: formatAmount,
                },
            ],
        });
    }
    handleSortChange = (sortModel) => {
        this.setState({ sortModel, currentPage: 1 }, this.getAllBookingData);
    }
    handleFilterChange = (filterModel) => {
        this.setState({ filterModel, currentPage: 1 }, this.getAllBookingData);
    }
    //Data Reload
    handleReload = () => {
        this.getAllBookingData();
    };
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.getAllBookingData);
    };
    handlePageSizeChange = (size) => {
        this.setState({ pageSize: size, currentPage: 1 }, this.getAllBookingData);
    };
    //Handle Add new Record
    handleEdit = (dataItem) => {
        this.setState({ redirectBookingStatus: true, selBookingId: dataItem.BookingId })
    }
    //Handle Spot Booking
    handleSpotBooking = (dataItem) => {
        this.setState({ redirectSpotBookingStatus: true, selBookingId: dataItem.BookingId })
    }
    //Redirect To Manage Booking Page
    redirectToBookingPage = () => {
        var { selBookingId, redirectBookingStatus, } = this.state;
        if (redirectBookingStatus === true && selBookingId > 0) {
            return <Redirect to={`/bk/${selBookingId}`} />
        }
    }
    //Redirect To Manage Spot Booking Page
    redirectToSpotBookingPage = () => {
        var { selBookingId, redirectSpotBookingStatus, } = this.state;
        if (redirectSpotBookingStatus === true && selBookingId > 0) {
            return <Redirect to={`/spot-bk/${selBookingId}`} />
        }
    }
    //render lifecycle event
    render() {
        const { data, columnDefs, currentPage, pageSize, totalRecords } = this.state;
        return (
            <>
                <div className="master-page">
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Booking List" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                        </div>
                    </div>
                </div>

                <div className="master-page__body">
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / pageSize) || 1}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                        onPageChange={this.handlePageChange}
                        onPageSizeChange={this.handlePageSizeChange}
                    />
                    <div className="master-page__grid">
                        <AgGridComponent
                            columnDefs={columnDefs}
                            rowData={data}
                            isLoading={this.state.isTableLoading}
                            onSortChange={this.handleSortChange}
                            onFilterChange={this.handleFilterChange}
                            fillHeight
                        />
                    </div>
                </div>
                </div>
                {this.redirectToBookingPage()}
                {this.redirectToSpotBookingPage()}
            </>
        );
    }
}

export default BookingList;
